import { CLIENT_NAMES } from "../constants";

export const PLATFORM_NAME = process.env.REACT_APP_PLATFORM_NAME;

export const CURRENT_CLIENT_NAME = process.env.REACT_APP_PLATFORM_NAME || CLIENT_NAMES.CONNECTIVE;